import { render, staticRenderFns } from "./StandardTemplate.vue?vue&type=template&id=8074d680&scoped=true"
import script from "./StandardTemplate.vue?vue&type=script&lang=js"
export * from "./StandardTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8074d680",
  null
  
)

export default component.exports